import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-profile",
  "use": "icon-profile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-profile\">\n<circle cx=\"12\" cy=\"8\" r=\"5\" />\n<path d=\"M6.5 21V21C5.11929 21 3.96122 19.8537 4.38543 18.5397C5.42327 15.3252 8.44009 13 12 13C15.5599 13 18.5767 15.3252 19.6146 18.5397C20.0388 19.8537 18.8807 21 17.5 21V21\" stroke-linecap=\"round\" />\n<path d=\"M10 19L11.5 20.5L14 18\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol